import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Header from '../../shared/Header/header.vue';
import SpinLoader from '../../shared/SpinLoader/spin.loader.vue';
import NavSide from '../../shared/NavSide/nav.side.vue';
import PreSaleDetailIntro from './PreSaleDetailIntro/presale.detail.intro.vue';
import { baseUrlEncoder } from '../../utils/baseurl.encoder';
import { PresaleDetailDelegate } from '../../services/DataDelegate/PresaleDelegate/presale.detail.delegate';
import ASpaceInBetweenAnother from '../../shared/ASpaceInBetweenAnother/a.space.inbetween.another.vue';
import * as T_T from 'cryface';
import { CommonFunc } from '../../services/DataDelegate/ComonDelegate/common.functions';

@Component({
    components: {
        Header,
        SpinLoader,
        NavSide,
        PreSaleDetailIntro,
        ASpaceInBetweenAnother
    }
})
export default class PreSaleDetailPage extends Vue {
    public title: string = 'PreSaleDetailPage';

    public isLoading = false;

    public output: any = null;

    public modal = false;

    public id: string = '';

    public isCapturing = false;

    public avatar = this.$store.state.auth.avatar;

    public dataDelegate = new PresaleDetailDelegate();

    public model = {
        identifier: 's14',
        pictureOne: 'https://picsum.photos/300/150/?image=30',
        pictureTwo: 'https://picsum.photos/300/150/?image=31',
        title: '',
        fullAddress: '',
        price: -10000,
        bedrooms: 0,
        bedroomsPlus: 0,
        washrooms: 0,
        garages: 0,
        parkingSpaces: 0,
        address: {},
        agentId: '',
        province: '',
        city: '',
        streetName: '',
        streetNumber: '',
        postalCode: '',
    };

    public userInfo = {
        id: 'N/A',
        name: '',
        phone: '',
        wechatQrcode: null,
        titleName: '',
        email: '',
        headImgUrl: null,
        mobile: '',
        slogan: '',
    };

    @Watch('$store.state.auth.avatar', { immediate: true, deep: true })
    public onAvatarDownloaded(val: any, oldVal: any) {
        if (T_T.simpleDetect(val)) {
            this.avatar = val;
        }
    }

    public async created() {
        this.$store.commit('selectSection', '6');
        this.id = this.$route.params.id;
        this.isLoading = true;
        const result = await this.dataDelegate.getDetail(this.id);
        if (result === 1) {
            this.model = this.dataDelegate.Data;
            const userInfoFetched = await CommonFunc.getAgentInfoByYHId(this.model.agentId);
            if (T_T.simpleDetect(userInfoFetched)) {
                this.userInfo.id = this.model.agentId;
                this.userInfo.phone = userInfoFetched.phone;
                this.userInfo.wechatQrcode = T_T.simpleDetect(userInfoFetched.wechatQrcode) ? userInfoFetched.wechatQrcode : null;
                this.userInfo.email = userInfoFetched.email;
                this.userInfo.headImgUrl = userInfoFetched.headImgUrl;
                this.userInfo.titleName = userInfoFetched.titleName;
                this.userInfo.mobile = userInfoFetched.mobile;
                this.userInfo.name = userInfoFetched.name;
                this.userInfo.slogan = userInfoFetched.slogan;
            }
        }
        this.isLoading = false;
    }

    public async letsCapture() {
        // console.log(ref);
        // this.$Loading.start();
        const el = this.$refs.printMe;
        // // add option type to get the image version
        // // if not provided the promise will return
        // // the canvas.
        const options = {
            type: 'dataURL'
        };
        const _this: any = this;
        this.output = await _this.$html2canvas(el, options);
        // this.output = dataURItoBlob(this.output!);
        this.modal = true;
        this.isCapturing = false;
        // this.$Loading.finish();
    }

    public dataURItoBlob(dataURI: string | null) {
        if (dataURI) {
            // convert base64 to raw binary data held in a string
            // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
            const byteString = atob(dataURI.split(',')[1]);

            // separate out the mime component
            const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to an ArrayBuffer
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            const convertedUrl = window.URL.createObjectURL(new Blob([ab], { type: mimeString }));
            return convertedUrl;
        }
    }

    public async capture() {
        const promises: Promise<any>[] = [];
        promises.push(
            new Promise(async (resolve, reject) => {
                this.model.pictureOne = await baseUrlEncoder(this.model.pictureOne);
                resolve(1);
            })
        );
        promises.push(
            new Promise(async (resolve, reject) => {
                this.model.pictureTwo = await baseUrlEncoder(this.model.pictureTwo);
                resolve(1);
            })
        );
        if (T_T.simpleDetect(this.userInfo.headImgUrl)) {
            promises.push(
                new Promise(async (resolve, reject) => {
                    this.userInfo.headImgUrl = await baseUrlEncoder(this.userInfo.headImgUrl!);
                    resolve(1);
                })
            );
        }
        if (T_T.simpleDetect(this.userInfo.wechatQrcode)) {
            promises.push(
                new Promise(async (resolve, reject) => {
                    this.userInfo.wechatQrcode = await baseUrlEncoder(this.userInfo.wechatQrcode!);
                    resolve(1);
                })
            );
        }
        await Promise.all(promises);
    }

    public async handleCapture() {
        this.isCapturing = true;
        await this.capture();
        this.letsCapture();
    }

}
